import router from '@/router'
import store from '@/store'
import _ from 'lodash'
import * as utilCompression from './compression'
import * as utilObj from './obj'
import * as utilDate from './date'
import * as numberFormat from './number'
import * as utilStr from './str'
import { swal as swalClass } from './sweetAlert2'

export { router, store, _ };
export const compression = utilCompression
export const obj = utilObj
export const dt = utilDate
export const num = numberFormat
export const str = utilStr
export const swal = new swalClass()